import React from 'react';

const TrafalgarLogo = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#4a90e2', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#2c5aa0', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="45" fill="url(#logoGrad)" stroke="#fff" strokeWidth="2"/>
      <text x="50" y="60" fontFamily="Arial, sans-serif" fontSize="24" fontWeight="bold" textAnchor="middle" fill="white">T</text>
    </svg>
  );
};

export default TrafalgarLogo;
